import { Injectable } from '@angular/core';

import { Admin, ServiceProvider } from '@models';
import { CrudService, HttpService } from '@services';

@Injectable({ providedIn: 'root' })
export class ServiceProviderService extends CrudService<ServiceProvider> {
  constructor(http: HttpService) {
    super('service-provider', http);
  }

  public async updateImage(
    file: File,
    serviceProvider: ServiceProvider
  ): Promise<ServiceProvider> {
    const res = await this.http.postWithFile<ServiceProvider>(
      `${this.url}/${serviceProvider.id}/image`,
      {},
      file
    );
    return res.data;
  }

  public async getAdmins(serviceProviderId: string): Promise<Admin[]> {
    const res = await this.http.get<Admin[]>(`${this.url}/${serviceProviderId}/admins`);
    return res.data;
  }

  public async addAdmin(
    serviceProvider: ServiceProvider,
    admin: Admin
  ): Promise<Admin> {
    const res = await this.http.post<Admin>(
      `${this.url}/${serviceProvider.id}/admin`,
      admin
    );
    return res.data;
  }

  override create(item: ServiceProvider): Promise<ServiceProvider> {
    throw new Error('cannot create service providers');
  }

  override delete(id: string): Promise<string> {
    throw new Error('cannot delete service providers');
  }
}


